'use client';

import React from 'react';
import { Theme } from '@mui/material';
import { SxProps } from '@mui/system/styleFunctionSx';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { CmsMarketingCampaignBlock } from '@/services/cms/blocks/CmsMarketingCampaignBlock';
import { MarketingCampaignBlockImagesGrid } from './components/MarketingCampaignBlockImagesGrid';
import { MarketingCampaignBlockImagesList } from './components/MarketingCampaignBlockImagesList';

export type MarketingCampaignBlockProps = {
    sx?: SxProps<Theme>;
} & CmsMarketingCampaignBlock;

export const MarketingCampaignBlock = (props: MarketingCampaignBlockProps) =>
    props.images ? (
        <BlockContainer {...props}>
            <BlockTitle {...props} />
            <MarketingCampaignBlockImagesGrid images={props.images || []} sx={{ display: { xs: 'none', sm: 'block' } }} />
            <MarketingCampaignBlockImagesList images={props.images || []} sx={{ display: { xs: 'flex', sm: 'none' } }} />
        </BlockContainer>
    ) : null;
